import axiosInstance from "../services/axiosInstance";

export const getAttendanceAnalytics = async ({ companyId, dateFrom, dateTo }) => {
  try {
    const response = await axiosInstance.get("console/analytics/attendance", {
      params: { company_id: companyId, date_from: dateFrom, date_to: dateTo },
    });
    return response.data;
  } catch (error) {
    return error.response?.data ?? { status: 500, message: "Network error" };
  }
};

export const getFinancialAnalytics = async ({ companyId, dateFrom, dateTo }) => {
  try {
    const response = await axiosInstance.get("console/analytics/financial", {
      params: { company_id: companyId, date_from: dateFrom, date_to: dateTo },
    });
    return response.data;
  } catch (error) {
    return error.response?.data ?? { status: 500, message: "Network error" };
  }
};
